/**
 * Pill cliquable — remplace checkbox/radio par défaut dans les filtres
 * (norme stack standard, borderRadius 999px).
 */
export default function Pill({ active = false, onClick, children, disabled = false, icon: Icon, color }) {
  const bg = active
    ? (color ?? 'var(--primary)')
    : 'var(--glass)';
  const fg = active ? '#fff' : 'var(--text)';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.4rem',
        padding: '0.4rem 0.9rem',
        borderRadius: 'var(--radius-pill)',
        border: '1px solid var(--glass-border)',
        background: bg,
        color: fg,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontSize: '0.85rem',
        fontWeight: active ? 600 : 400,
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
      }}
    >
      {Icon && <Icon size={14} />}
      {children}
    </button>
  );
}
